// import React, { useEffect, useState } from "react";
// import "./Coupon_Card.css";
// import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Blue_Btn from "../common_btn/blue_btn/Blue_Btn";
// import {
//   getCouponCode,
//   getCoupon,
// } from "../../../utils/apis/orderProcess/orderProcess";

// const Coupon_Card = ({ showtc, orderAmount }) => {
//   const [coupons, setCoupons] = useState([]);
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     fetchCoupons();
//   }, []);

//   const fetchCoupons = async () => {
//     const res = await getCoupon();
//     if (res?.success) {
//       setCoupons(res.data);
//     }
//   };

//   //  Apply coupon on button click
//   const applyCoupon = async (code) => {
//     setError("");

//     const res = await getCouponCode(code, orderAmount);

//     if (res?.success) {
//       const coupon = res.data;

//       let discountAmount = 0;

//       if (coupon.type === "percentage") {
//         discountAmount = (orderAmount * coupon.discount) / 100;
//       } else {
//         discountAmount = coupon.discount;
//       }

//       const finalAmount = orderAmount - discountAmount;

//       setAppliedCoupon({
//         ...coupon,
//         discountAmount,
//         finalAmount,
//       });
//     } else {
//       setAppliedCoupon(null);
//       setError(res?.message);
//     }
//   };

//   return (
//     <>
//       {coupons.map((item) => (
//         <section className="Coupon_Card" key={item.id}>
//           <div className="top_div">
//             <div className="left_side">
//               <img
//                 src="/assets/Image/checkout/discount.png"
//                 className="discount_img"
//                 alt=""
//               />
//               <p className="coupon_code">{item.code}</p>
//             </div>

//             <div className="apply_div">
//               <Blue_Btn
//                 btn_name="Apply"
//                 onClick={() => applyCoupon(item.code)}
//               />
//             </div>
//           </div>

//           <div className="content_text_div">
//             <p className="main_text">
//               {item.coupon_message}
//               <span className="save_text">
//                 {" "}
//                 Save {item.discount}% on this order!
//               </span>
//             </p>

//             <ul>
//               <li className="point_text">
//                 Minimum order ₹{item.minimum_order}
//               </li>
//               <li className="point_text">
//                 Use per customer: {item.use_per_customer}
//               </li>
//             </ul>

//             {showtc && (
//               <div className="tc_div">
//                 <p className="tc_text">
//                   Terms & Conditions <FontAwesomeIcon icon={faAngleRight} />
//                 </p>
//               </div>
//             )}
//           </div>
//         </section>
//       ))}

//       {/*  Applied Coupon */}
//       {appliedCoupon && (
//         <p className="success_text">
//           Coupon "{appliedCoupon.code}" applied successfully!
//         </p>
//       )}

//       {/*  Error Message */}
//       {error && <p className="error_text"> {error}</p>}
//     </>
//   );
// };

// export default Coupon_Card;

import React, { useEffect, useState } from "react";
import "./Coupon_Card.css";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_Btn from "../common_btn/blue_btn/Blue_Btn";
import {
  getCouponCode,
  getCoupon,
} from "../../../utils/apis/orderProcess/orderProcess";
import { Link } from "react-router-dom";
import Success_Modal_Coupon from "../../Common_modal/success_modal2/Success_Modal_Coupon";

const Coupon_Card = ({
  applyCoupons,
  setApplyCoupons,
  showtc,
  orderAmount,
  onApplyCoupon,
  error,
  setError,
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    const res = await getCoupon();
    if (res?.success) {
      setCoupons(res.data);
    }
  };

  // const applyCoupon = async (coupon) => {
  //   setError("");

  //   const res = await getCouponCode(coupon.code, orderAmount);

  //   if (res?.success) {

  //     let discountAmount = 0;

  //     if (coupon.type === "percentage") {
  //       discountAmount = (orderAmount * Number(coupon.discount)) / 100;
  //     } else {
  //       discountAmount = Number(coupon.discount);
  //     }

  //     setAppliedCoupon({
  //       ...coupon,
  //       discountAmount,
  //     });

  //     onApplyCoupon({
  //       discountAmount,
  //       code_id: coupon.id,
  //       code: coupon.code,
  //     });
  //   } else {
  //     setAppliedCoupon(null);
  //     setError(res?.message);
  //   }
  // };

  const applyCoupon = async (coupon) => {
    setError("");

    // send only code to API
    const res = await getCouponCode(coupon.code, orderAmount, applyCoupons);

    if (res?.success) {
      setApplyCoupons((prev) => {
        const exists = prev.includes(coupon.code);
        if (exists) return prev;
        return [...prev, coupon.code];
      });
      setAppliedCoupon(res?.data);
      setModalShow(true);

      setTimeout(() => {
        setModalShow(false);
      }, 2000);
    } else {
      setError(res?.message || "Invalid Coupon");
    }
  };

  const removeCoupon = (code) => {
    setApplyCoupons((prev) => prev.filter((c) => c !== code));
  };

  return (
    <>
      {coupons.map((item) => (
        <section className="Coupon_Card" key={item.id}>
          <div className="top_div">
            <div className="left_side">
              <img
                src="/assets/Image/checkout/discount.png"
                className="discount_img"
                alt=""
              />
              <p className="coupon_code">{item.code}</p>
            </div>

            <div className="apply_div">
              {applyCoupons.some((c) => c === item.code) ? (
                <Blue_Btn
                  btn_name="Remove"
                  onClick={() => removeCoupon(item.code)}
                />
              ) : (
                <Blue_Btn btn_name="Apply" onClick={() => applyCoupon(item)} />
              )}
            </div>
          </div>

          <div className="content_text_div">
            <p className="main_text">
              {item.coupon_message}
              <span className="save_text">
                {" "}
                Save {item.discount}% on this order!
              </span>
            </p>

            <ul>
              <li className="point_text">
                Minimum order ₹{item.minimum_order}
              </li>
              <li className="point_text">
                Use per customer: {item.use_per_customer}
              </li>
            </ul>

            {showtc && (
              <div className="tc_div">
                <p className="tc_text">
                  <Link to={"/terms"}>
                    Terms & Conditions <FontAwesomeIcon icon={faAngleRight} />
                  </Link>
                </p>
              </div>
            )}
          </div>
        </section>
      ))}

      {appliedCoupon && (
        <p className="success_text">
          Coupon "{appliedCoupon.code}" applied successfully!
        </p>
      )}

      {error && <p className="error_text">{error}</p>}

      <Success_Modal_Coupon
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Coupon Applied SuccessFully !"
      />
    </>
  );
};

export default Coupon_Card;
